import script from "./DispatchPackagingMeasuresDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DispatchPackagingMeasuresDialog.vue?vue&type=script&setup=true&lang=js"

import "./DispatchPackagingMeasuresDialog.vue?vue&type=style&index=0&id=301b003c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-301b003c"]])

export default __exports__